import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { Label } from '../../../../components/styled/global.style'
import {
  AutocompleteStyle,
  FormError,
  InputBaseStyle,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../Trade.style'
import { OptionContainer } from '../../Trade.style'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'
import FlagCurrency from '../../../../components/FlagCurrency/FlagCurrency'
import CurrencyLogo from '../../../../components/CurrencyLogo/CurrencyLogo'
import SelectWithArrow from '../../../../components/SelectWithArrow/SelectWithArrow'

const DigitalKnockInKnockOutTrade = ({
  form,
  handelFormChange,
  handelDateChange,
  currencyData,
  currencyInitial,
  disabled = false,
  errors
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Spot Ref *</Label>
        <InputBaseStyle
          name="spot_ref"
          placeholder="0.00"
          value={form.spot_ref}
          disabled={disabled}
          onChange={handelFormChange}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Payout Amount *</Label>
        <TextFieldStyle
          type="text"
          variant="outlined"
          placeholder="0.00"
          name="payout_amount"
          disabled={disabled}
          value={form.payout_amount}
          onChange={handelFormChange}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Payout Currency*</Label>
        {Array.isArray(currencyData.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'payout_currency'
              element = element ?? currencyInitial
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.payout_currency}
            getOptionLabel={option => option.name}
            options={currencyData.data}
            renderInput={params => (
              <TextFieldModalStyle
                {...params}
                fullWidth
                placeholder="Select Currency"
                disabled={disabled}
              />
            )}
            disabled={disabled}
            renderOption={(props, option) => (
              <OptionContainer {...props} key={option.id}>
                <FlagCurrency countryCode={option.code3} />
                <CurrencyLogo currencyCode={option.name} />
                <Typography style={{ marginLeft: 'auto' }}>{option.name} </Typography>
              </OptionContainer>
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Barrier *</Label>
        <InputBaseStyle
          name="barrier"
          placeholder="0.00"
          value={form.barrier}
          disabled={disabled}
          onChange={handelFormChange}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Window Start *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.window_start}
          myerror={String(!!errors.window_start)}
          disabled={disabled}
          onChange={event => handelDateChange('window_start', event.target.value)}
        />
        {errors.window_start && <FormError>{errors.window_start}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>Window End *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.window_end}
          disabled={disabled}
          onChange={event => handelDateChange('window_end', event.target.value)}
        />
      </Box>

      <Box width={'100%'}>
        <Label>Timing *</Label>
        <SelectWithArrow
          name="timing"
          placeholder="Select Timing"
          orderType={form.timing}
          onChange={handelFormChange}
          disabled={disabled}
          background="#39393C"
          items={[{ name: 'SETTLEMENT' }, { name: 'EXPIRY' }]}
        />
      </Box>
    </>
  )
}

export default DigitalKnockInKnockOutTrade

DigitalKnockInKnockOutTrade.propTypes = {
  handelFormChange: PropTypes.func,
  handelDateChange: PropTypes.func,
  currencyData: PropTypes.object,
  currencyInitial: PropTypes.object,
  disabled: PropTypes.bool,
  form: PropTypes.object,
  errors: PropTypes.object
}
